import React from 'react'
import "./Text.css"

const Text = () => {
  return (
    <div>
      <div className="section11">
          <div className="container11">
            <div className="content-section11">
              <div className="title11">
                <h1>Factory Photos</h1>
              </div>
              <div className="content11">
                <br></br>
                {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
                <p>Just the essentials include the best manufacturing facilities with enormous capacity, cutting-edge machinery backed by an automated production line, quick computers, the newest technology, and a technical staff with extensive backgrounds in a variety of sectors</p>
                <p>At Somnath Polytex, our commitment to excellence begins with our state-of-the-art manufacturing infrastructure. We take immense pride in our production facilities, where innovation, technology, and sustainability converge to create high-quality packaging materials for a variety of industries</p>
                <p>Our facilities are equipped with cutting-edge machinery that exemplifies precision and efficiency. From extrusion lines and weaving machines to printing equipment, we utilize the latest technology to ensure the highest quality in every product we create. Our investment in advanced machinery is a testament to our dedication to meeting and exceeding industry standards.</p>
                <p>Quality is the cornerstone of our manufacturing process. We have dedicated quality control and testing units in place to ensure that every product bearing the Somnath Polytex name is of superior quality. Our quality control measures include material inspection, dimensional accuracy checks, strength and durability testing, and more.</p>
                {/* <div className="button">
                  <a href="">Read More</a>
                </div> */}
              </div>
              <div className="social">
                {/* <a href=""><i className='fab fa-facebook-f'></i></a>
                <a href=""><i className='fab FaTwitter'></i></a>
                <a href=""><i className='fab fa-instagram'></i></a> */}
              </div>
            </div>
            {/* <div className="image-section">
              <img src="/images/6.jpg" alt="" />
            </div> */}
          </div>
        </div>
    </div>
  )
}

export default Text
